import oneTimeApplePaySchema from './oneTimeApplePaySchema';

const oneTimePaymentSchema = {
  ...oneTimeApplePaySchema,
  payFromAccount: [{
    rule: 'required',
    error: 'This field is required',
  }],
};

export default oneTimePaymentSchema;
